/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { ChangeEvent, useCallback, useEffect, useState } from "react";
import { GetDeliveryOrderByIdObject } from "../../../@types/DRO/DeliveryOrderResponse";
import { Approver } from "../../../@types/DRO/GetAllApproverResponse";
import { GetAllProductListApiResponse } from "../../../@types/DRO/GetAllProductResponse";
import { GetAllVendorsListApiResponse } from "../../../@types/DRO/GetAllVendorsResponse";
import { GetAllWarehouseApiResponse } from "../../../@types/DRO/GetAllWarehouseResponse";
import {
  GetAllModelTypeArray,
  TransferOrderPartDetails,
} from "../../../@types/DRO/GetPartsListResponse";
import { PurchaseOrderBody } from "../../../@types/DTO/CreatePurchaseOrderBody";
import { ReturnOrder } from "../../../@types/DTO/ReturnOrderBody";
import { DeliveryOrderApi } from "../../../api/DeliveryOrder/DeliveryOrderApi";
import { DeliveryReturnApi } from "../../../api/DeliveryReturn/DeliveryReturnApi";
import { GetAllApproverListApi } from "../../../api/GetApproversList/GetAllApproverListApi";
import { AllPartApi } from "../../../api/GetParts/GetAllPartsApi";
import { GetAllVendorsListApi } from "../../../api/GetVendorsList/GetAllVendorsListApi";
import { GetAllWarehouseListApi } from "../../../api/GetWarehouseList/GetAllWarehouseListApi";
import { ProductOrderApi } from "../../../api/ProductOrder/ProductOrderApi";

interface ReturnToVendorProps {
  onBack: () => void;
  orderData?: any | null;
  orderDataId?: number | null;
}

const ReturnToVendor: React.FC<ReturnToVendorProps> = ({
  onBack,
  orderData,
  orderDataId,
}) => {
  const [items, setItems] = useState([
    {
      description: "",
      quantity: "",
      unit: "Units",
      price: "",
      taxes: "",
      total: "",
    },
  ]);

  const [newItem, setNewItem] = useState({
    description: "",
    quantity: "",
    unit: "Units",
    price: "",
    taxes: "",
    total: "",
  });

  const [vendors, setVendors] = useState<
    GetAllVendorsListApiResponse["data"]["data"]
  >([]);
  const [warehouses, setWarehouses] = useState<
    GetAllWarehouseApiResponse["data"]["data"]
  >([]);
  const [selectedVendor, setSelectedVendor] = useState("");
  const [selectedGSTTreatment, setSelectedGSTTreatment] = useState("");
  const [selectedWarehouses, setSelectedWarehouses] = useState<string[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState("");
  const [approvers, setApprovers] = useState<Approver[]>([]);
  const [selectedApprovers, setSelectedApprovers] = useState<string[]>([]);
  const [orderDeadline, setOrderDeadline] = useState("");
  const [showAddItemRow, setShowAddItemRow] = useState(false);
  const [products, setProducts] = useState<
    GetAllProductListApiResponse["data"]
  >([]);
  const [orderType, setOrderType] = useState("OPEN");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [parts, setParts] = useState<TransferOrderPartDetails[]>([]);
  const [modelTypes, setModelTypes] = useState<GetAllModelTypeArray[]>([]);
  const [selectedOEMTypeId, setSelectedOEMTypeId] = useState<number | null>(
    null
  );
  const [returnOrder, setReturnOrder] = useState<ReturnOrder | null>(null);
  const [orderDetails, setSingleOrderDetails] =
    useState<GetDeliveryOrderByIdObject>();
  const fetchPartsByOEMType = useCallback(async (oemTypeId: number) => {
    try {
      const response = await AllPartApi.api.getPartList(oemTypeId);
      setParts(response.data.data);
    } catch (error) {
      console.error("Error fetching parts by OEM type", error);
    }
  }, []);

  const handleCloseModal = () => {
    setModalOpen(false);
    if (isSuccess) {
      window.location.reload();
    }
  };

  useEffect(() => {
    if (orderData) {
      setSelectedVendor(orderData.vendorDetails?.vendorName || "");
      setSelectedGSTTreatment(orderData.gstTreatment || "");
      const formattedDate = orderData.expectedArrival
        ? new Date(orderData.expectedArrival).toISOString().slice(0, 16)
        : "";
      setOrderDeadline(formattedDate);
      setOrderType(orderData.purchaseOrderType || "OPEN");
      setSelectedWarehouses(
        orderData.deliveryWareHouseDetails?.deliveryWarehouseName
          ? [orderData.deliveryWareHouseDetails.deliveryWarehouseName]
          : []
      );
    }
  }, [orderData]);

  const fetchModelTypes = useCallback(async () => {
    try {
      const response = await AllPartApi.api.getModelTypeAll();
      setModelTypes(response.data);
    } catch (error) {
      console.error("Error fetching model types", error);
    }
  }, []);

  const fetchVendors = useCallback(
    async (resetPage = false) => {
      try {
        const response = await GetAllVendorsListApi.api.getAllVendorsList(
          resetPage ? 1 : page + 1,
          rowsPerPage,
          searchQuery
        );
        setVendors((prevVendors) =>
          resetPage
            ? response.data.data
            : [...prevVendors, ...response.data.data]
        );
      } catch (error) {
        console.error("Error fetching vendors", error);
      }
    },
    [page, rowsPerPage, searchQuery]
  );

  const fetchWarehouses = useCallback(async () => {
    try {
      const response = await GetAllWarehouseListApi.api.getAllWarehouseList();
      setWarehouses(response.data.data);
    } catch (error) {
      console.error("Error fetching warehouses", error);
    }
  }, []);

  const fetchApprovers = useCallback(async () => {
    try {
      const response = await GetAllApproverListApi.api.getAllApproverList();
      setApprovers(response.data);
    } catch (error) {
      console.error("Error fetching approvers", error);
    }
  }, []);

  const fetchParts = useCallback(async () => {
    try {
      const response = await AllPartApi.api.getPartList();
      setParts(response.data.data);
    } catch (error) {
      console.error("Error fetching parts", error);
    }
  }, []);

  const fetchReturnedOrders = useCallback(async () => {
    if (!orderDataId) return;

    try {
      const response = await DeliveryReturnApi.api.getReturnOrderResponse(
        orderDataId
      );
      setReturnOrder(response.data);
    } catch (error) {
      console.error("Error fetching parts", error);
    }
  }, []);

  const singleOrderData = useCallback(async () => {
    if (!orderDataId) return null;

    try {
      const response = await DeliveryOrderApi.api.getSingleDeliverOrderDetails(
        orderDataId
      );

      if (response?.data) {
        setSingleOrderDetails(response.data);
      }
    } catch (error) {
      console.error("Error fetching order details", error);
    }
  }, [orderDataId]);

  useEffect(() => {
    fetchReturnedOrders();
  }, [fetchReturnedOrders]);

  useEffect(() => {
    if (selectedOEMTypeId !== null) {
      fetchPartsByOEMType(selectedOEMTypeId);
    } else {
      fetchParts();
    }
  }, [selectedOEMTypeId, fetchPartsByOEMType, fetchParts]);

  useEffect(() => {
    fetchVendors(true);
    fetchWarehouses();
    fetchApprovers();
    fetchParts();
    fetchModelTypes();
  }, [
    rowsPerPage,
    searchQuery,
    fetchVendors,
    fetchWarehouses,
    fetchApprovers,
    fetchParts,
    fetchModelTypes,
  ]);

  const handleScroll = (event: React.SyntheticEvent) => {
    const bottom =
      event.currentTarget.scrollHeight - event.currentTarget.scrollTop ===
      event.currentTarget.clientHeight;
    if (bottom) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    fetchVendors();
  }, [page, fetchVendors]);

  const handleAddItem = () => {
    setItems([...items, newItem]);
    setNewItem({
      description: "",
      quantity: "",
      unit: "",
      price: "",
      taxes: "",
      total: "",
    });
  };

  const handleDeleteItem = (index: number) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
  };

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => {
    setNewItem({ ...newItem, [field]: e.target.value });
  };

  const handlePageChange = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    setPage(0);
  };

  const handleCreateAndSendForApproval = async () => {
    try {
      const vendor = vendors.find((v) => v.name === selectedVendor);
      const selectedWarehouseObjs = warehouses.filter((w) =>
        selectedWarehouses.includes(w.name)
      );
      if (!vendor || !selectedWarehouseObjs.length) {
        console.error("Vendor or at least one Warehouse not selected");
        return;
      }

      const orderBody: PurchaseOrderBody = {
        vendorId: vendor.id,
        deliveryWarehouseId: selectedWarehouseObjs.map((w) => w.id),
        confirmationDate: new Date().toISOString(),
        expectedArrival: orderDeadline,
        gst: selectedGSTTreatment,
        purchaseOrderType: orderType,
        statusType: "CREATED",
        purchaseOrderLineRequestList: items.map((item) => ({
          partId:
            parts.find((part) => part.description === item.description)?.id ||
            0,
          quantityOrdered: parseInt(item.quantity, 10),
          price: parseFloat(item.price.replace(/[^\d.-]/g, "")),
        })),
        requiredApprovals: approvers
          .filter((approver) => selectedApprovers.includes(approver.name))
          .map((approver) => approver.userId),
        note: "",
      };

      await ProductOrderApi.api.createPurchaseOrder(orderBody);
      console.log("Purchase order created and sent for approval");
      setIsSuccess(true);
      setModalMessage(
        "Purchase order created and sent for approval successfully."
      );
      setModalOpen(true);
    } catch (error) {
      console.error(
        "Error creating and sending purchase order for approval",
        error
      );
      setIsSuccess(false);
      setModalMessage(
        "Error creating and sending purchase order for approval."
      );
      setModalOpen(true);
    }
  };

  const handleCreateAndDraft = async () => {
    try {
      const vendor = vendors.find((v) => v.name === selectedVendor);
      const selectedWarehouseObjs = warehouses.filter((w) =>
        selectedWarehouses.includes(w.name)
      );
      if (!vendor || !selectedWarehouseObjs.length) {
        console.error("Vendor or at least one Warehouse not selected");
        return;
      }

      const orderBody: PurchaseOrderBody = {
        vendorId: vendor.id,
        deliveryWarehouseId: selectedWarehouseObjs.map((w) => w.id),
        confirmationDate: new Date().toISOString(),
        expectedArrival: orderDeadline,
        gst: selectedGSTTreatment,
        purchaseOrderType: orderType,
        statusType: "DRAFT",
        purchaseOrderLineRequestList: items.map((item) => ({
          partId:
            parts.find((part) => part.description === item.description)?.id ||
            0,
          quantityOrdered: parseInt(item.quantity, 10),
          price: parseFloat(item.price.replace(/[^\d.-]/g, "")),
        })),
        requiredApprovals: approvers
          .filter((approver) => selectedApprovers.includes(approver.name))
          .map((approver) => approver.userId),
        note: "",
      };

      const orderId = "1";
      await ProductOrderApi.api.updatePurchaseOrder(orderId, orderBody);
      setModalMessage("Purchase order created and drafted successfully.");
      setIsSuccess(true);
      setModalOpen(true);
      console.log("Purchase order created and drafted");
    } catch (error) {
      console.error("Error creating and drafting purchase order", error);
      setModalMessage("Error creating and drafting purchase order.");
      setIsSuccess(false);
      setModalOpen(true);
    }
  };
  const calculateTotals = () => {
    let totalAmount = 0;
    let totalGST = 0;

    items.forEach((item) => {
      const quantity = parseInt(item.quantity, 10) || 0;
      const price = parseFloat(item.price) || 0;
      const taxRate = parseFloat(item.taxes.replace("%", "")) / 100 || 0;

      const itemTotal = quantity * price;
      const itemGST = itemTotal * taxRate;

      totalAmount += itemTotal;
      totalGST += itemGST;
    });

    return {
      totalAmount: totalAmount.toFixed(2),
      totalGST: totalGST.toFixed(2),
      overallTotal: (totalAmount + totalGST).toFixed(2),
    };
  };

  const { totalAmount, totalGST, overallTotal } = calculateTotals();
  return (
    <div className="flex min-h-screen bg-gray-50">
      <div className="w-full p-4">
        {/* Header Section */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              fontWeight: "600",
              color: "#1E1E1E",
              textAlign: "left",
              fontSize: "1.5rem",
              // mb: 2,
            }}>
            Return To Vendor
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#F8F9FA",
              padding: "12px 16px",
              borderRadius: "8px",
            }}>
            <Button
              onClick={onBack}
              sx={{
                textTransform: "none",
                color: "#646464",
                p: 0,
                fontSize: "0.875rem",
                "&:hover": {
                  color: "#1E1E1E",
                  backgroundColor: "transparent",
                },
              }}>
              Dashboard
            </Button>
            <Typography variant="body2" color="#646464" sx={{ mx: 1 }}>
              &gt;
            </Typography>
            <Button
              onClick={onBack}
              sx={{
                textTransform: "none",
                color: "#646464",
                p: 0,
                fontSize: "0.875rem",
                "&:hover": {
                  color: "#1E1E1E",
                  backgroundColor: "transparent",
                },
              }}>
              Delivery
            </Button>
            <Typography variant="body2" color="#646464" sx={{ mx: 1 }}>
              &gt;
            </Typography>
            <Typography
              variant="body2"
              color="#1E1E1E"
              sx={{ fontWeight: "500", fontSize: "0.875rem" }}>
              Delivery Details
            </Typography>
          </Box>
        </Box>
        <Paper
          sx={{
            p: 4,
            borderRadius: "8px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            backgroundColor: "white",
            maxWidth: "1600px",
            margin: "0 auto",
          }}>
          {/* Form Section */}
          <Box sx={{ mb: 4 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Box>
                  <label className="block text-gray-600 text-sm font-medium text-start mb-1">
                    Vendor Name
                  </label>
                  <Autocomplete
                    fullWidth
                    options={vendors}
                    getOptionLabel={(option) => option.name}
                    value={
                      vendors.find(
                        (vendor) => vendor.name === selectedVendor
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      setSelectedVendor(newValue ? newValue.name : "");
                      setSelectedGSTTreatment(newValue?.gst ?? "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        InputProps={{
                          ...params.InputProps,
                          style: { fontSize: "0.875rem" },
                        }}
                      />
                    )}
                    onScroll={handleScroll}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                <Box>
                  <label className="block text-gray-600 text-sm font-medium text-start mb-1">
                    Operation Type
                  </label>
                  <TextField
                    fullWidth
                    value={selectedGSTTreatment}
                    variant="standard"
                    InputProps={{
                      readOnly: true,
                      style: { fontSize: "0.875rem" },
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                <Box>
                  <label className="block text-gray-600 text-sm font-medium text-start mb-1">
                    Order Deadline
                  </label>
                  <TextField
                    fullWidth
                    type="datetime-local"
                    value={orderDeadline}
                    onChange={(e) => setOrderDeadline(e.target.value)}
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      style: { fontSize: "0.875rem" },
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                <Box>
                  <label className="block text-gray-600 text-sm font-medium text-start mb-1">
                    Destination Location
                  </label>
                  <Autocomplete
                    fullWidth
                    multiple
                    options={warehouses}
                    getOptionLabel={(option) => option.name}
                    value={warehouses.filter((warehouse) =>
                      selectedWarehouses.includes(warehouse.name)
                    )}
                    onChange={(event, newValue) => {
                      setSelectedWarehouses(newValue.map((w) => w.name));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        InputProps={{
                          ...params.InputProps,
                          style: { fontSize: "0.875rem" },
                        }}
                      />
                    )}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Items Section */}
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="subtitle1"
              sx={{
                textAlign: "left",
                fontWeight: "600",
                color: "#1E1E1E",
                mb: 2,
                fontSize: "1.125rem",
              }}>
              Items
            </Typography>

            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#F8F9FA" }}>
                    <TableCell sx={{ fontWeight: "600", fontSize: "0.875rem" }}>
                      #
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.875rem",
                        width: "300px",
                      }}>
                      Product Description
                    </TableCell>
                    <TableCell sx={{ fontWeight: "600", fontSize: "0.875rem" }}>
                      Quantity
                    </TableCell>
                    <TableCell sx={{ fontWeight: "600", fontSize: "0.875rem" }}>
                      Unit Of Measure
                    </TableCell>
                    <TableCell sx={{ fontWeight: "600", fontSize: "0.875rem" }}>
                      Unit Price
                    </TableCell>
                    <TableCell sx={{ fontWeight: "600", fontSize: "0.875rem" }}>
                      Tax
                    </TableCell>
                    <TableCell sx={{ fontWeight: "600", fontSize: "0.875rem" }}>
                      Total
                    </TableCell>
                    <TableCell sx={{ fontWeight: "600", fontSize: "0.875rem" }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ fontSize: "0.875rem" }}>
                        {index + 1}
                      </TableCell>
                      <TableCell>
                        <Autocomplete
                          options={parts}
                          getOptionLabel={(option) => option.description}
                          value={
                            parts.find(
                              (part) => part.description === item.description
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            const newItems = [...items];
                            if (newValue) {
                              newItems[index].description =
                                newValue.description;
                              newItems[index].unit = "Units";
                              newItems[index].price = newValue.price.toString();
                              newItems[index].taxes = "18%";
                              const quantity =
                                parseInt(newItems[index].quantity, 10) || 0;
                              const price = parseFloat(
                                newValue.price.toString()
                              );
                              const taxRate = 0.18;
                              const total = quantity * price * (1 + taxRate);
                              newItems[index].total = total.toFixed(2);
                            } else {
                              newItems[index].description = "";
                              newItems[index].unit = "";
                              newItems[index].price = "";
                              newItems[index].taxes = "";
                              newItems[index].total = "";
                            }
                            setItems(newItems);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              InputProps={{
                                ...params.InputProps,
                                style: { fontSize: "0.875rem" },
                              }}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={item.quantity}
                          onChange={(e) => {
                            const newItems = [...items];
                            const inputValue = e.target.value;

                            if (inputValue === "0") {
                              return;
                            }

                            newItems[index].quantity = inputValue;
                            const quantity = parseInt(inputValue, 10) || 0;
                            const price =
                              parseFloat(newItems[index].price) || 0;
                            const taxRate = 0.18;
                            const total = quantity * price * (1 + taxRate);
                            newItems[index].total = total.toFixed(2);
                            setItems(newItems);
                          }}
                          onBlur={() => {
                            const newItems = [...items];
                            const quantity = parseInt(
                              newItems[index].quantity,
                              10
                            );
                            if (isNaN(quantity) || quantity < 1) {
                              newItems[index].quantity = "1";
                            }
                            setItems(newItems);
                          }}
                          variant="standard"
                          disabled={!item.description}
                          InputProps={{
                            style: { fontSize: "0.875rem" },
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={item.unit}
                          variant="standard"
                          disabled
                          InputProps={{
                            style: { fontSize: "0.875rem" },
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={item.price}
                          onChange={(e) => {
                            const newItems = [...items];
                            newItems[index].price = e.target.value;
                            const quantity =
                              parseInt(newItems[index].quantity, 10) || 0;
                            const price = parseFloat(e.target.value) || 0;
                            const taxRate = 0.18;
                            const total = quantity * price * (1 + taxRate);
                            newItems[index].total = total.toFixed(2);
                            setItems(newItems);
                          }}
                          variant="standard"
                          disabled={!item.description}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                ₹
                              </InputAdornment>
                            ),
                            style: { fontSize: "0.875rem" },
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={item.taxes}
                          variant="standard"
                          disabled={!item.description}
                          InputProps={{
                            style: { fontSize: "0.875rem" },
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={item.total}
                          variant="standard"
                          disabled={!item.description}
                          InputProps={{
                            style: { fontSize: "0.875rem" },
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <IconButton
                          onClick={() => handleDeleteItem(index)}
                          sx={{ color: "#FF0000" }}
                          size="small">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* Totals and Actions Section */}
          <Box sx={{ mt: 3 }}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              <Button
                variant="contained"
                color="error"
                sx={{
                  padding: "8px 20px",
                  borderRadius: "32px",
                  textTransform: "none",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                  backgroundColor: "#F94932",
                }}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleCreateAndDraft}
                sx={{
                  padding: "8px 20px",
                  borderRadius: "32px",
                  backgroundColor: "#1366D9",
                  textTransform: "none",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                  "&:hover": { backgroundColor: "#1366D9" },
                }}>
                Create And Draft
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleCreateAndSendForApproval}
                sx={{
                  padding: "8px 20px",
                  borderRadius: "32px",
                  backgroundColor: "#1E1E1E",
                  textTransform: "none",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                  "&:hover": { backgroundColor: "#000000" },
                }}>
                Return to Vendor
              </Button>
            </Box>
          </Box>
        </Paper>
      </div>
    </div>
  );
};

export default ReturnToVendor;
